import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";

import starstSvg from "./starts.svg";

export default function StartsSvg({ width = 300, height = 230 }) {
  return (
    <EmbedSvg
      imgKey="startsSvg"
      src={starstSvg}
      width={width}
      height={height}
    />
  );
}
